import styled from 'styled-components';
import { DateOption } from '../../../DateOption';

export const CustomFilterOption = styled(DateOption)`
	padding: 10px 0 10px 0;
`;
